(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerHeight() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    var value = parseFloat(raw);
    return value > 0 ? value : 72;
  }

  function groupsFrom(root) {
    return Array.prototype.slice
      .call(root.querySelectorAll('.van__col'))
      .map(function (col) {
        var head = col.querySelector('.van__col-head');
        var titleEl = head ? head.querySelector('span') || head : null;
        var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var anchors = Array.prototype.slice
          .call(col.querySelectorAll('a.van__item[href^="#"]'))
          .map(function (link) {
            return (link.getAttribute('href') || '').replace(/^#/, '');
          })
          .filter(Boolean);
        if (!title || !anchors.length) return null;
        var styles = head ? getComputedStyle(head) : null;
        return {
          title: title,
          anchors: anchors,
          href: '#' + anchors[0],
          bg: styles ? styles.backgroundColor : '',
          fg: styles ? styles.color : '',
        };
      })
      .filter(Boolean);
  }

  function init(root) {
    var nav = root.querySelector('[data-van-sticky]');
    var toc = root.querySelector('[data-van-toc]') || root.querySelector('.van__cols');
    if (!nav || !toc) return;

    if (root.getAttribute('data-van-ready') === '1') return;

    var groups = groupsFrom(root);
    if (!groups.length) return;
    root.setAttribute('data-van-ready', '1');

    var shell = document.createElement('div');
    shell.className = 'van-sticky__shell';
    var track = document.createElement('div');
    track.className = 'van-sticky__track';
    var rail = document.createElement('span');
    rail.className = 'van-sticky__rail';
    rail.setAttribute('aria-hidden', 'true');
    var railFill = document.createElement('span');
    railFill.className = 'van-sticky__rail-fill';
    rail.appendChild(railFill);
    var indicator = document.createElement('span');
    indicator.className = 'van-sticky__indicator';
    indicator.setAttribute('aria-hidden', 'true');
    track.appendChild(rail);
    track.appendChild(indicator);

    groups.forEach(function (group, index) {
      var link = document.createElement('a');
      link.className = 'van-sticky__step';
      link.href = group.href;
      link.dataset.vanStep = String(index);
      var num = document.createElement('span');
      num.className = 'van-sticky__num';
      num.textContent = String(index + 1);
      var label = document.createElement('span');
      label.className = 'van-sticky__label';
      label.textContent = group.title;
      link.appendChild(num);
      link.appendChild(label);
      if (group.bg) link.style.setProperty('--van-step-bg', group.bg);
      if (group.fg) link.style.setProperty('--van-step-fg', group.fg);
      track.appendChild(link);
    });

    shell.appendChild(track);
    nav.appendChild(shell);

    var steps = nav.querySelectorAll('.van-sticky__step');
    var activeIndex = -1;
    var animating = false;
    var animFrame = 0;
    var scrollTick = 0;

    function setStickyHeight() {
      var height = nav.offsetHeight || 64;
      document.documentElement.style.setProperty('--van-sticky-h', height + 'px');
    }

    function showNav(visible) {
      nav.classList.toggle('is-visible', visible);
      nav.setAttribute('aria-hidden', visible ? 'false' : 'true');
      setStickyHeight();
      if (!visible) return;
      window.requestAnimationFrame(function () {
        layoutRail();
        if (activeIndex >= 0) moveChrome(activeIndex);
      });
    }

    function tocIsOnScreen() {
      var rect = toc.getBoundingClientRect();
      var header = headerHeight();
      return rect.bottom > header && rect.top < window.innerHeight;
    }

    function syncVisibility() {
      showNav(!tocIsOnScreen());
    }

    function layoutRail() {
      if (!steps.length) return;
      var firstNum = steps[0].querySelector('.van-sticky__num');
      var lastNum = steps[steps.length - 1].querySelector('.van-sticky__num');
      if (!firstNum || !lastNum) return;
      var trackRect = track.getBoundingClientRect();
      var firstRect = firstNum.getBoundingClientRect();
      var lastRect = lastNum.getBoundingClientRect();
      var start = firstRect.left + firstRect.width / 2 - trackRect.left;
      var end = lastRect.left + lastRect.width / 2 - trackRect.left;
      rail.style.left = start + 'px';
      rail.style.width = Math.max(0, end - start) + 'px';
      rail.style.top = firstRect.top + firstRect.height / 2 - trackRect.top - 1 + 'px';
    }

    function moveChrome(index) {
      var step = steps[index];
      if (!step) return;
      layoutRail();
      var trackRect = track.getBoundingClientRect();
      var stepRect = step.getBoundingClientRect();
      var left = stepRect.left - trackRect.left;
      indicator.style.width = stepRect.width + 'px';
      indicator.style.transform = 'translate3d(' + left + 'px, 0, 0)';
      indicator.style.setProperty('--van-step-bg', step.style.getPropertyValue('--van-step-bg'));
      indicator.style.setProperty('--van-step-fg', step.style.getPropertyValue('--van-step-fg'));
      var max = Math.max(groups.length - 1, 1);
      railFill.style.width = (index / max) * 100 + '%';
      window.requestAnimationFrame(function () {
        indicator.classList.add('is-ready');
        railFill.classList.add('is-ready');
      });
    }

    function setActive(index) {
      if (index < 0 || index === activeIndex) return;
      activeIndex = index;
      Array.prototype.forEach.call(steps, function (step, i) {
        var on = i === index;
        step.classList.toggle('is-active', on);
        if (on) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      moveChrome(index);
    }

    function setActiveFromHash(hash) {
      var id = String(hash || '').replace(/^#/, '');
      var index = -1;
      groups.forEach(function (group, i) {
        if (group.anchors.indexOf(id) !== -1) index = i;
      });
      if (index !== -1) setActive(index);
    }

    function setActiveFromScroll() {
      if (animating || tocIsOnScreen()) return;
      var line = headerHeight() + (nav.classList.contains('is-visible') ? nav.offsetHeight : 0) + 16;
      var current = -1;
      groups.forEach(function (group, i) {
        group.anchors.forEach(function (id) {
          var el = document.getElementById(id);
          if (!el) return;
          if (el.getBoundingClientRect().top <= line) current = i;
        });
      });
      if (current === -1) return;
      setActive(current);
    }

    function stopScrollAnim() {
      if (animFrame) window.cancelAnimationFrame(animFrame);
      animFrame = 0;
    }

    function animateScrollTo(id, done) {
      var el = document.getElementById(id);
      if (!el) {
        if (done) done();
        return;
      }
      if (prefersReducedMotion()) {
        el.scrollIntoView({ behavior: 'auto', block: 'start' });
        if (done) done();
        return;
      }
      var margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      var start = window.pageYOffset;
      var dest = Math.max(0, start + el.getBoundingClientRect().top - margin);
      var dist = dest - start;
      if (Math.abs(dist) < 2) {
        if (done) done();
        return;
      }
      var duration = Math.min(820, Math.max(480, Math.abs(dist) * 0.42));
      var t0 = performance.now();
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      function ease(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      function finish() {
        animFrame = 0;
        root.style.scrollBehavior = prevBehavior;
        if (done) done();
      }
      function tick(now) {
        var p = Math.min(1, (now - t0) / duration);
        window.scrollTo(0, start + dist * ease(p));
        if (p < 1) {
          animFrame = window.requestAnimationFrame(tick);
        } else {
          finish();
        }
      }
      stopScrollAnim();
      animFrame = window.requestAnimationFrame(tick);
    }

    function goToGroup(index, href) {
      var id = String(href || '').replace(/^#/, '');
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + id);
      } else {
        window.location.hash = id;
      }
      animating = true;
      setActive(index);
      animateScrollTo(id, function () {
        animating = false;
        setActiveFromScroll();
      });
    }

    Array.prototype.forEach.call(steps, function (step, index) {
      step.addEventListener('click', function (event) {
        event.preventDefault();
        goToGroup(index, groups[index].href);
      });
    });

    window.addEventListener(
      'scroll',
      function () {
        if (scrollTick) return;
        scrollTick = window.requestAnimationFrame(function () {
          scrollTick = 0;
          syncVisibility();
          if (!animating) setActiveFromScroll();
        });
      },
      { passive: true },
    );
    window.addEventListener(
      'resize',
      function () {
        syncVisibility();
        setActiveFromScroll();
        if (activeIndex >= 0 && !tocIsOnScreen()) moveChrome(activeIndex);
      },
      { passive: true },
    );
    window.addEventListener('hashchange', function () {
      syncVisibility();
      if (!tocIsOnScreen()) setActiveFromHash(window.location.hash);
    });
    window.addEventListener('popstate', function () {
      syncVisibility();
      if (tocIsOnScreen()) return;
      var id = window.location.hash.replace(/^#/, '');
      setActiveFromHash(window.location.hash);
      if (!id) return;
      animating = true;
      animateScrollTo(id, function () {
        animating = false;
        setActiveFromScroll();
      });
    });

    syncVisibility();
    if (!tocIsOnScreen()) {
      setActiveFromHash(window.location.hash);
      setActiveFromScroll();
    }
  }

  function boot() {
    document.querySelectorAll('[data-van-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  var tries = 0;
  var timer = window.setInterval(function () {
    boot();
    tries += 1;
    if (tries > 25 || document.querySelector('[data-van-root][data-van-ready="1"]')) {
      window.clearInterval(timer);
    }
  }, 80);
})();
